import { t } from 'i18next';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';

import { IPermission, PermissionStatusType } from '../../../../../../../../hooks/api/permissions';
import styles from './PermissionStatus.module.css';

const determineTagClass = (status: PermissionStatusType) => {
  switch (status) {
    case PermissionStatusType.WITHDRAWN:
      return styles['withdrawn-tag'];
    default:
      return '';
  }
};

const determineStatusText = (status: PermissionStatusType) => {
  switch (status) {
    case PermissionStatusType.WITHDRAWN:
      return t('permission.withdrawn');
    default:
      return '';
  }
};

type PermissionStatusProps = {
  permission: IPermission;
};

const PermissionStatus = ({ permission }: PermissionStatusProps) => {
  const text = determineStatusText(permission.status);

  const tagClass = determineTagClass(permission.status);

  if (!text || !tagClass) {
    return null;
  }

  return (
    <Tag rounded className={classNames('text-sm font-medium px-2 py-1', tagClass)}>
      {text}
    </Tag>
  );
};

export default PermissionStatus;
